export enum RewardType {
    Nothing = "Nothing",
    Points = "Points",
    Flames = "Flames"
};
